"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const R = __importStar(require("ramda"));
const initialState = {};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "genesys-properties-selector/TOGGLE_GROUP": {
            const settings = state[action.propertiesSelectorId];
            if (!settings) {
                const propertiesSelectorSettings = Object.assign(Object.assign({}, getInitialSettings()), { closedGroups: { [action.groupName]: true } });
                return R.assocPath([action.propertiesSelectorId], propertiesSelectorSettings, state);
            }
            if (!settings.closedGroups[action.groupName]) {
                return R.assocPath([action.propertiesSelectorId, "closedGroups", action.groupName], true, state);
            }
            return R.dissocPath([action.propertiesSelectorId, "closedGroups", action.groupName], state);
        }
        case "genesys-properties-selector/TOGGLE_QUANTITY_SELECTOR": {
            const settings = state[action.propertiesSelectorId];
            if (!settings) {
                const propertiesSelectorSettings = Object.assign(Object.assign({}, getInitialSettings()), { activatedQuantitySelectors: { [action.propertyName]: true } });
                return R.assocPath([action.propertiesSelectorId], propertiesSelectorSettings, state);
            }
            if (!settings.activatedQuantitySelectors[action.propertyName]) {
                return R.assocPath([
                    action.propertiesSelectorId,
                    "activatedQuantitySelectors",
                    action.propertyName
                ], true, state);
            }
            return R.dissocPath([
                action.propertiesSelectorId,
                "activatedQuantitySelectors",
                action.propertyName
            ], state);
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
function getInitialSettings() {
    return {
        closedGroups: {},
        activatedQuantitySelectors: {}
    };
}
//# sourceMappingURL=reducer.js.map